// /src/mixins/searchMixin.js
import uniqBy from 'lodash/uniqBy'
import isUndefined from 'lodash/isUndefined'
import isNaN from 'lodash/isNaN'
import _omit from 'lodash/omit'
import _values from 'lodash/values'
import _each from 'lodash/each'
import _isNaN from 'lodash/isNaN'
import _pick from 'lodash/pick'
import _keys from 'lodash/keys'
import _map from 'lodash/map'
import _some from 'lodash/some'
import _orderBy from 'lodash/orderBy'
import _cloneDeep from 'lodash/cloneDeep'
import _dropWhile from 'lodash/dropWhile'
import _takeWhile from 'lodash/takeWhile'
import _filter from 'lodash/filter'
import _union from 'lodash/union'
import _remove from 'lodash/remove'
import _isArray from 'lodash/isArray'
import _isBoolean from 'lodash/isBoolean'
import { deepSearch, dynamicSort } from '@/components/common/utils/helpers.js'

export default {
  data() {
    return {
      bookmarkLoading: false,
      showFilters: false,
      activeQueries: [],
    }
  },

  computed: {
    verticals() {
      return this.$store.getters['taxies/getAll']('verticals')
    },
  },

  methods: {
    async getActiveQueries() {
      const { $route } = this
      let { query } = $route
      query = _omit(query, ['page', 'sort', 'search', 'sort_by_meta', 'filter '])
      const queryValues = Object.entries(query).map(([type, name]) => {
        return {type, name}
      })

      return await Promise.all(
          queryValues.map(async q => {
            // let queryItem = {}
          let {name, type} = q
          const numberValue = parseInt(name)
          type = type.replace('session_', '').replace('_', ' ')
          if (numberValue) {
            const queryItem = await this.$store.getters['taxies/filterItemsByProp'](
              type,
              numberValue,
            )
            name = typeof queryItem[0] != 'undefined' ? queryItem[0].name : name
          }
          return {
              buttonText: _isBoolean(name) || (name == "true" || name == "false" || name == '') ? type : `${type}: ${name}`,
              name,
              type,
              originalQuery: q,
          }
          
        })
      )
    },
    /**
     * Search Object Array filtering to search input.
     * @param {array} objectList - List of Session Objects to be filters
     * @borrows deepSearch to find value of deeply nested properties
     * @return {array} List of Session Objects left after search
     */
    filterCards(objectList) {
      const { page, search, ...searchProps } = Object.assign(
        {},
        this.$route.query,
      )
      if (Object.keys(searchProps).length == 0) return objectList
      Object.entries(searchProps).forEach(([key, value]) => {
        const numberValue = parseInt(value)
        value = isNaN(numberValue) ? value : numberValue
        switch (key) {
          case 'deal_phases':
            key =
              typeof key == 'string' && key.includes('_')
                ? key.replace('_', '-')
                : key
            objectList = objectList.filter(item => item[key] == value)
            break
          case 'sort':
            const sortValue = value.split('+')
            objectList =
              sortValue[0] == 'default'
                ? this.mikeSort(objectList)
                : objectList.sort(dynamicSort(sortValue))
            break
          case 'authors':
          case 'tags':
          case 'services':
          case 'industries':
          case 'deal_types':
          case 'geographies':
          case 'origin':
          case 'subtitle_groups':
            objectList = objectList.filter(item => {
              if (item[key]) return item[key].includes(value)
            })
            break
          case 'user_groups':
            objectList = objectList.filter(item => {
              if (item[key] && item[key].length > 0) {
                const groupValues = _map(item[key][0], val => parseInt(val))
                return groupValues.includes(value)
              }
            })
            break
          case 'verticals':
            const { verticals } = this
            objectList = objectList.filter(item => {
              const itemObj = verticals.find(
                obj =>
                  !isUndefined(obj) &&
                  (obj.id == value || (obj.parent > 0 && obj.parent == value)),
              )
              if (!isUndefined(itemObj) && item[key] == itemObj.parent)
                return true
              if (item[key]) return item[key].includes(value)
            })
            break

          // case 'type':
          //   if (value == 'documents') {
          //     let output = []
          //     objectList.map(t => {
          //       let downloadableFiles = deepSearch(t, ['acf', 'downloadable_files'])
          //       if (downloadableFiles && Array.isArray(downloadableFiles)) {
          //         downloadableFiles.forEach(file => {
          //           const fileObj = file.file
          //           if (fileObj && typeof fileObj == 'object') {
          //             // console.log(file)
          //             output.push({
          //               ...t,
          //               post_title: fileObj.title,
          //               file: fileObj,
          //               post_type: 'downloadable_file',
          //             })
          //           }
          //         })
          //       }
          //     })
          //   } else {
          //     objectList = objectList.filter(item => item[key] == value)
          //     break
          //   }
            // return output      
          default:
            objectList = objectList.filter(item => {
              return item[key] == value})
            break
        }
      })
      return objectList
    },

    /**
     * Search Object Array filtering to search input.
     * @param {array} objectList - List of Session Objects to be filters
     * @borrows deepSearch to find value of deeply nested properties
     * @return {array} List of Session Objects left after search
     */
    searchViaInput(objectList) {
      const { search } = Object.assign({}, this.$route.query)
      if (isUndefined(search)) return objectList
      let searchArray = search
        .split('OR')
        .map(i => i.trim())
        .filter(i => i != '')

      // define the list of properties you want to searched
      // currently default query results and api results are different
      const searchList = [
        // 'title+rendered',
        'post_title',
        'lookup+tags@taxies@tags+*+name',
        'content+_raw+0+content',
        'post_type',
        'type',
        'lookup+subtitle_groups@taxies@subtitle_groups+*+name',
        'lookup+origin@taxies@origin+*+name',
        'lookup+verticals@taxies@verticals+*+name',
        'acf+display_author+*+name',
        'session_type',
        'lookup+deal_types@taxies@deal_types+*+name',
        'lookup+deal-phases@taxies@deal-phases+*+name',
      ]

      let output = []
      searchList.forEach(searchItemProp => {
        // because props and values were passed via had to come up with a way to drill into props to search value and landed on a string broked down into array. If this feels janky we are open to suggestions
        const searchItems = searchItemProp.split('+')

        output.push(
          objectList.filter(item => {
            // get value to be searched for within object
            let searchString = deepSearch(item, searchItems)

            if (
              searchString !== '' &&
              (typeof searchString == 'string' || Array.isArray(searchString))
            ) {
              searchString =
                typeof searchString == 'string'
                  ? searchString.toLowerCase()
                  : searchString.join(' ').toLowerCase()

              const searchFound = searchArray.find(search =>
                searchString.includes(search.toLowerCase()),
              )
              return typeof searchFound !== 'undefined'
            } else {
              return false
            }
          }),
        )
      })
      output = uniqBy(output.flat(), 'id')
      return output
    },

    recursiveSort(sortList, objectList) {
      // const output =
      if (sortList.childSearches.length > 0) {
        sortList.childSearches.forEach(childSearch => {
          this.recursiveSearch(childSearch)
        })
      }
    },

    mikeSort(objectList) {
      const { search } = Object.assign({}, this.$route.query)
      const list = _cloneDeep(objectList)
      const typesOrder = ['course', ['session', 'documents'], 'relationships']
      const searchList = [
        [
          // {
          //   lookupProp: 'title+rendered',
          //   values: [search],
          //   childSort: [],
          // },
          // need to test to verify this works with two in one array
          {
            lookupProp: 'post_title',
            values: [search],
            childSort: [],
          },
        ],
        [
          {
            lookupProp: 'lookup+tags@taxies@tags+*+name',
            values: [search],
            childSort: [],
          },
        ],
        [
          {
            lookupProp: 'content+_raw+0+content',
            values: [search],
            childSort: [],
          },
        ],
      ]

      let groupList = [
        [
          {
            lookupProp: 'lookup+subtitle_groups@taxies@subtitle_groups+*+name',
            values: [
              'Course',
              'Documents',
              'Basics',
              'Quick Hits',
              'National Meeting',
              'Producers Podcast',
              'Agent FAQ',
              'Training',
              'Training Calls',
              'Tailoring the Message',
              'Company Update',
              'Kickoff Call',
              'Encouragement',
              'Deal by Phase',
              'Quick Parts',
              'Article',
              'Presentation',
              'Ad Template',
              'Marketing',
              'Case Study',
              'Events',
              'Profile',
              'Lead Generation',
              'Resources',
              'Financing',
              'Technology',
              'CoStar',
              'Salesforce',
              'Onboarding',
              'Dental',
              'Medical',
              'Other Healthcare',
              'Veterinary',
              'Vision',
              'National Accounts',
              'Corporate Relationships',
            ],
            childSort: [],
          },
        ],
      ]
      let sortList = []
      if (search) {
        _each(searchList, (list, key) => {
          _each(list, (item, index) => {
            return _each(groupList, (group, k) => {
              _each(group, (groupItem, i) => {
                return searchList[key][index].childSort.push(groupItem)
              })
            })
          })
        })
        sortList = searchList
      } else {
        sortList = groupList
      }
      // console.log(sortList)
      // sortList = groupList
      const output = []

      _each(typesOrder, (type, index) => {
        const group = _remove(list, itm => type.includes(itm.type))
        _each(sortList, (sort, sIndex) => {
          _each(sort, (sortItems, sIIndex) => {
            const propertyLookup = sortItems.lookupProp.split('+')
            _each(sortItems.values, sortItem => {
              let deepSort = _remove(group, item => {
                return this.searchStringChecks(
                  deepSearch(item, propertyLookup),
                  [sortItem],
                )
              })
              if (deepSort.length > 0 && sortItems.childSort.length > 0) {
                _each(sortItems.childSort, (childSort, cIndex) => {
                  const childPropertyLookup = childSort.lookupProp.split('+')
                  _each(childSort.values, childSortItem => {
                    const sortedChildren = _remove(deepSort, item => {
                      return this.searchStringChecks(
                        deepSearch(item, childPropertyLookup),
                        [childSortItem],
                      )
                    })
                    deepSort.push(...sortedChildren)
                  }).length > 0
                })
              }
              output.push(...deepSort)
            })
          })
        })
        // push anything back into group that wasn't sorted
        output.push(...group)
      })

      return output
    },

    toggleFilters() {
      this.showFilters = !this.showFilters
    },

    searchStringChecks(searchString, searchArray) {
      if (
        searchString !== '' &&
        (typeof searchString == 'string' || Array.isArray(searchString))
      ) {
        searchString =
          typeof searchString == 'string'
            ? searchString.toLowerCase()
            : searchString.join(' ').toLowerCase()

        const searchFound = searchArray.find(search =>
          searchString.includes(search.toLowerCase()),
        )
        return typeof searchFound !== 'undefined'
      } else {
        return false
      }
    },

    initialCaps(string) {
      return string
        .split(' ')
        .map(word => {
          return word[0].toUpperCase() + word.substr(1)
        })
        .join(' ')
    },

    removeFilterItem(queryItem) {
      let { query, name } = this.$route
      query = _omit(query, queryItem.type)
      this.$router.push({
        name,
        query,
      })
    },
  },
}
